type RuntimeConfig = Record<string, string | undefined>;

type RuntimeGlobal = typeof globalThis & {
  __QUIZIVA_CONFIG__?: RuntimeConfig;
  process?: { env?: RuntimeConfig };
};

export function runtimeConfigValue(name: string): string {
  const runtime = globalThis as RuntimeGlobal;
  return runtime.__QUIZIVA_CONFIG__?.[name] ?? runtime.process?.env?.[name] ?? '';
}

/** Deployment features fail closed; only the exact normalized value `true` enables one. */
export function runtimeConfigFlagEnabled(name: string): boolean {
  return runtimeConfigValue(name).trim().toLowerCase() === 'true';
}
